import { create } from 'zustand';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';

const isWeb = false;

const storage = isWeb
  ? createJSONStorage(() => localStorage)
  : createJSONStorage(() => AsyncStorage);

interface UserStore {
  token?: string;
  setToken: (token?: string) => void;
  isLoadingToken: boolean;
  setIsLoadingToken: (isLoadingToken: boolean) => void;
  previousPassword?: string;
  previousEmail?: string;
  setPreviousPassword: (previousPassword?: string) => void;
  setPreviousEmail: (previousEmail?: string) => void;
  rememberMe: boolean;
  setRememberMe: (rememberMe: boolean) => void;
}

export const useUserStore = create<UserStore>()(
  devtools(
    persist(
      (set) => ({
        previousPassword: undefined,
        setPreviousPassword: (previousPassword) => {
          return set({ previousPassword });
        },

        previousEmail: undefined,
        setPreviousEmail: (previousEmail) => {
          return set({ previousEmail });
        },
        rememberMe: true,
        setRememberMe: (rememberMe) => {
          return set({ rememberMe });
        },
        token: undefined,
        setToken: (token) => {
          return set({ token });
        },
        isLoadingToken: true,
        setIsLoadingToken: (isLoadingToken) => {
          return set({ isLoadingToken });
        },
      }),
      {
        name: 'user-store',
        partialize: (state) => {
          return { ...state, isLoadingToken: true };
        },
        storage: storage,
        onRehydrateStorage: (a) => {
          return (b) => {
            b?.setIsLoadingToken(false);
          };
        },
      }
    )
  )
);
